import React from 'react';
import Logo from './Logo';

const Navbar = () => {
  return (
    <nav className="absolute w-full z-50 py-4">
      <div className="container mx-auto px-4 flex justify-center items-center">
        <Logo className="w-80" />
      </div>
    </nav>
  );
};

export default Navbar;